// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"62ec7487","84":"35f5ee10","216":"499768b8","659":"465df23d"}[chunkId] + ".chunk.js";
};